<template>
  <LimitTagList
    :entity="LIMIT_TAG_LIST_ENTITIES.WORKSPACE"
    :filtered-out="filteredOut"
    :items="workspacesList"
    :limit="limit"
    data-testid="workspaces-cell"
    style="--list-gap: 4px; --count-offset: 0"
    tooltip-value="tooltipLabel"
  >
    <template #item="{ item: workspace }">
      <AppIcon
        v-if="workspace.hidden"
        class="wlc-LockedWs"
        height="24"
        icon-name="lock-next"
        width="24"
      />
      <WorkspaceIcon :option="workspace" />
    </template>
  </LimitTagList>
</template>

<script setup>
import { computed } from 'vue'

import { LIMIT_TAG_LIST_ENTITIES } from '@/utils/components-configurations/limit-tag-list'

import LimitTagList from '@/components/form/LimitTagList'
import AppIcon from '@/components/ui/AppIcon/AppIcon'
import WorkspaceIcon from '@/components/workspaces/WorkspaceIcon'

defineOptions({
  name: 'WorkspacesListCell'
})

const props = defineProps({
  filteredOut: {
    type: Boolean
  },

  workspaces: {
    type: Array,
    required: true
  },

  limit: {
    type: Number,
    default: 4
  }
})

const workspacesList = computed(() => {
  return props.workspaces.map(workspace => {
    const { name, key, hidden } = workspace
    const resolvedKey = hidden ? '∗' : key
    const resolvedName = hidden ? '∗∗∗∗∗∗' : name
    return {
      ...workspace,
      tooltipLabel: `[${resolvedKey}] ${resolvedName}`
    }
  })
})
</script>

<style lang="scss" scoped>
.wlc-LockedWs {
  flex-shrink: 0;
  color: $dark-2;
}
</style>
